export default __webpack_public_path__ + "static/media/Loads-page.c5e51809.png";